import StantMultiselect from "../../../utils/stant_multiselect.coffee"

$(document).on 'turbolinks:load', ->
  new StantMultiselect('report-occurences-multiselect').add_listener()